/** Shared setting category labels + ordering used across SettingsReader, SettingsDiff, etc. */

export const CATEGORY_LABELS: Record<string, string> = {
  battery: 'Battery',
  generator: 'Generator',
  grid: 'Grid & Export',
  tou: 'Time of Use',
  safety: 'Safety',
  parallel: 'Parallel',
  other: 'Other',
};

export const CATEGORY_ORDER = ['battery', 'generator', 'grid', 'tou', 'safety', 'parallel', 'other'] as const;
